import { IonContent, IonLabel, IonSegment, IonSegmentButton, IonSegmentView } from '@ionic/react';
import { useId } from 'react';
import ModalHeader from '../../components/modals/ModalHeader';
import ModalWrapper from '../../components/modals/ModalWrapper';
import ContactUsContent from './segment-contents/ContactUsContent';
import FaqsContent from './segment-contents/FaqsContent';
import { IModal } from '../../router/ModalRouter';
import { useTranslation } from 'react-i18next';

const HelpAndFaqsModal = ({ goBack, closeModal }: Partial<IModal>) => {
  const { t } = useTranslation(null, { keyPrefix: 'Modules:Mobile:Modals:HelpAndFaq:HelpAndFaqsModal' });
  const faqsId = useId();
  const contactUsId = useId();
  const buttons = [
    {
      id: faqsId,
      title: t('buttons.faqs'),
    },
    {
      id: contactUsId,
      title: t('buttons.contact_us'),
    },
  ];

  return (
    <>
      <ModalWrapper className="mt-4">
        <ModalHeader title={t('title')} onBack={() => goBack()} onClose={closeModal} />
        <IonContent className="min-h-[75dvh] [&::part(scroll)]:px-md [&::part(scroll)]:py-md">
          <IonSegment value={faqsId} className="min-h-8 rounded-[30px] bg-mobile-notice">
            {buttons.map(({ id, title }) => (
              <IonSegmentButton
                key={id}
                value={id}
                contentId={id}
                className="text-xs font-medium m-1 [&::part(indicator-background)]:!bg-brand-primary [&::part(indicator-background)]:rounded-[30px] text-muted-foreground [&.segment-button-checked]:text-white stroke-mobile-tertiary [&.segment-button-checked]:stroke-white"
              >
                <IonLabel>{title}</IonLabel>
              </IonSegmentButton>
            ))}
          </IonSegment>
          <IonSegmentView className="pt-md">
            <FaqsContent id={faqsId} />
            <ContactUsContent id={contactUsId} />
          </IonSegmentView>
        </IonContent>
      </ModalWrapper>
    </>
  );
};

export default HelpAndFaqsModal;
